import React from 'react';
import { StarIcon, MapPinIcon } from 'lucide-react';
import { longTestimonials } from '../data/testimonials';
import { Reveal } from './ui/Reveal';
export function TestimonialsSection() {
  return <section aria-labelledby="familias-title" className="border-b border-line bg-surface/40" data-id="element-252" data-mp="1n0k8fihpzo8n">
      <div className="mx-auto max-w-content px-5 py-12 sm:px-8 lg:py-16" data-id="element-253" data-mp="1r142gd6zybqk">
        <h2 id="familias-title" className="mx-auto max-w-2xl text-center text-lg font-black leading-tight tracking-tight text-ivory sm:text-2xl" data-id="element-254" data-mp="1qz9kn7r0uzqp">
          Más familias que ya lo tienen
        </h2>

        <ul className="mt-6 grid gap-4 sm:grid-cols-2" data-id="element-255" data-mp="141ohcg15rpz1">
          {longTestimonials.map((t, i) => <Reveal key={t.name} delay={i * 0.04} className="h-full" data-id="element-256" data-mp="181zxpgmhn44p" data-mpi={i}>
              <li className="flex h-full flex-col rounded-2xl border border-line bg-surface p-4" data-id="element-257" data-mp="2yf7hlxmkpmo1">
                <div className="flex items-center gap-3" data-id="element-258" data-mp="32gsp13gc98qu">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-surfaceAlt text-[11px] font-bold text-accent" data-id="element-259" data-mp="32g991sa90ufg">
                    {t.initials}
                  </span>
                  <div className="min-w-0" data-id="element-260" data-mp="2q27uf9iv7kex">
                    <p className="text-[12px] font-bold tracking-tight text-ivory" data-id="element-261" data-mp="34r48bn7lrrng">{t.name}</p>
                    <p className="flex items-center gap-1 text-[10px] text-muted" data-id="element-262" data-mp="2zskphvob2vzb">
                      <MapPinIcon aria-hidden="true" className="h-3 w-3 shrink-0" data-id="element-263" data-mp="2zuneccdq2j2g" />
                      {t.city}
                      {t.role ? ` · ${t.role}` : ''}
                    </p>
                  </div>
                  <span className="ml-auto flex shrink-0 gap-0.5" aria-label="5 de 5 estrellas" data-id="element-264" data-mp="2m0mn03p3nyc4">
                    {Array.from({
                  length: 5
                }).map((_, s) => <StarIcon key={s} aria-hidden="true" className="h-3 w-3 fill-accent text-accent" data-id="element-265" data-mp="2h0i64cka51ld" data-mpi={s} />)}
                  </span>
                </div>
                <blockquote className="mt-3 text-[12px] leading-snug text-ivory" data-id="element-266" data-mp="3dqwevapaopb">
                  “{t.quote}”
                </blockquote>
              </li>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}